import { Api } from '@/utils/Api'

import { isLocalId } from '@/utils/Id'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const FLOORS_LOAD = 'FLOORS_LOAD'
export const FLOOR_LOAD = 'FLOOR_LOAD'
export const FLOOR_CREATE = 'FLOOR_CREATE'
export const FLOOR_UPDATE = 'FLOOR_UPDATE'
export const FLOOR_DESTROY = 'FLOOR_DESTROY'
export const FLOOR_STATE_UPDATE = 'FLOOR_STATE_UPDATE'

const floorsApi = new Api(UrlStore.FLOORS)
const floorSchema = new schema.Entity('floors')

export default {
  namespaced: true,
  state: {
    floorsLoaded: false,
    floorsList: [],
    entities: {
      floors: {}
    }
  },
  getters: {
    floorsNonLocal(state) {
      return state.floorsList
        .filter((fId) => !isLocalId(fId))
        .map((fId) => state.entities.floors[fId])
        .sort((a, b) => {
          return a.building_id - b.building_id || b.sort - a.sort
        })
    },
    floors(state) {
      return state.floorsList.map((fId) => state.entities.floors[fId])
    },
    floorsPublished(state, getters) {
      return getters.floors.filter((f) => f.status === 1)
    },
    getFloor: (state) => (floorId) => state.entities.floors[floorId] || null,
    getBuildingPublishedFloors: (state, getters) => (buildingId = null) => {
      return getters.floors.filter((floor) => floor.status && floor.building_id === buildingId)
    },
    getFloorMapUpdatedAt: (state) => (floorId) => {
      let floor = state.entities.floors[floorId]
      if (floor) {
        return floor.map_updated_at
      }
      return ''
    }
  },
  mutations: {
    [FLOORS_LOAD](state, payload) {
      let normData = normalize(payload.items, [floorSchema])
      state.floorsList = normData.result
      setEntities(state, normData)
    },
    [FLOOR_LOAD](state, payload) {
      let normData = normalize(payload, floorSchema)
      setEntities(state, normData)
    },
    [FLOOR_CREATE](state, floor) {
      state.floorsList.unshift(floor.id)
      Vue.set(state.entities.floors, floor.id, floor)
    },
    [FLOOR_UPDATE](state, floor) {
      if (floor.id && state.entities.floors[floor.id]) {
        state.entities.floors[floor.id] = Object.assign({}, state.entities.floors[floor.id], floor)
      }
    },
    [FLOOR_DESTROY](state, floor) {
      let num = state.floorsList.findIndex((cId) => cId === floor.id)
      if (num !== -1) {
        state.floorsList.splice(num, 1)
        delete state.entities.floors[floor.id]
      }
    },
    [FLOOR_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    floorsLoad({ commit }, config = {}) {
      floorsApi.getAll(config).then((r) => {
        commit(FLOORS_LOAD, r.data)
        commit(FLOOR_STATE_UPDATE, { floorsLoaded: true })
      })
    },
    floorLoad({ commit }, config) {
      floorsApi.get({ id: config.id, config: config }).then((r) => {
        commit(FLOOR_LOAD, r.data)
      })
    },
    floorSave({ getters, commit }, { floor, config = {} }) {
      if (!floor.id) throw new Error('Floor id is not present in `floorSave`!')
      commit(getters.getFloor(floor.id) ? FLOOR_UPDATE : FLOOR_CREATE, floor)
      let floorUpdated = getters.getFloor(floor.id)

      return floorsApi.save(floorUpdated, config).then((r) => {
        if (r._isNew) {
          commit(FLOOR_DESTROY, floorUpdated) // local
          commit(FLOOR_CREATE, r.data)
        } else {
          commit(FLOOR_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    floorDestroy({ commit }, floor) {
      floorsApi.destroy({ id: floor.id }).then(() => {
        commit(FLOOR_DESTROY, floor)
      })
    }
  }
}
